import React, { createContext, useContext, useState } from "react";

const CityStockContext = createContext(null);
const CityStockReportContext = createContext(null);

export function CityStockProvider({ cityUser, realUser, children }) {
  return (
    <CityStockContext.Provider value={{ cityUser, realUser }}>
      {children}
    </CityStockContext.Provider>
  );
}

export function useCityStock() {
  return useContext(CityStockContext);
}

export function useStockUser() {
  const ctx = useCityStock();
  return ctx?.cityUser || JSON.parse(localStorage.getItem("userData"));
}

export function useRealUser() {
  const ctx = useCityStock();
  return ctx?.realUser || JSON.parse(localStorage.getItem("userData"));
}

export function CityStockReportProvider({ children }) {
  const [selectedCity, setSelectedCity] = useState(null);
  return (
    <CityStockReportContext.Provider value={{ selectedCity, setSelectedCity }}>
      {children}
    </CityStockReportContext.Provider>
  );
}

export function useCityStockReport() {
  return useContext(CityStockReportContext);
}
